import * as React from 'react';
import PortfolioPage from "@components/Portfolio";
import { connect } from 'react-redux';
import { StoreState, Portfolio } from '@store/index';
import { Helmet } from "react-helmet";
import { withRouter, RouteComponentProps } from 'react-router-dom';

export interface Props extends RouteComponentProps { 
    portfolios: Portfolio[];
    technologies: string[];
}

const PortfolioContainer: React.SFC<Props> = (props: Props) => {
    const {portfolios, technologies} = props;
    const title = 'Portfolio - Nick Avasiloi | Full Stack Web Developer, Artificial Intelligence Specialist';
    const description = 'Project list which I did last years';
    const url = process.env.REACT_APP_URL + props.location.pathname;

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta name="og:title" content={title} />
                <meta name="og:description" content={description} />
                <meta name="og:url" content={url} />
            </Helmet>
            <PortfolioPage portfolios={portfolios} technologies={technologies} />
        </>
    );
}

const PortfolioContainerConnected = connect<{}, {}, Props>(
    (state: StoreState) => {
        const { portfolios, technologies } = state;

        return { portfolios, technologies: technologies.portfolio }
    }
)(PortfolioContainer);

const PortfolioContainerRouted = withRouter(PortfolioContainerConnected);

export default PortfolioContainerRouted;


// WEBPACK FOOTER //
// ./src/containers/Portfolio/index.tsx